var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#023047;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.8,1c0.4,0,0.8,0.3,0.8,0.8V8c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5V5.5l0.1,0c0.3,0,0.6,0,0.8,0 c0.1,0,0.3,0.1,0.4,0.2C9.9,5.7,10,5.8,10,6v2c0,0.3,0.2,0.5,0.5,0.5S11,8.3,11,8V6.4c0,0,0.1,0,0.1,0c0.3,0,0.6,0,0.7,0 c0.1,0,0.3,0.2,0.5,0.4c0.1,0.1,0.1,0.2,0.2,0.3v1.3C12.5,8.8,12.7,9,13,9s0.5-0.2,0.5-0.5v-1h0.3c0.6,0,1,0.4,1,1c0,0,0,0.1,0,0.1 l-0.3,2.7c0,0.3-0.1,0.7-0.3,1l-1.4,2.4c-0.1,0.2-0.3,0.3-0.4,0.3H6c-0.2,0-0.3-0.1-0.4-0.2l-1.4-2.2C4.1,12.4,4,12.2,3.9,12 L3.6,8.9c0-0.3,0.1-0.5,0.4-0.5l1-0.2V9c0,0.3,0.2,0.5,0.5,0.5S6,9.3,6,9V1.8C6,1.3,6.3,1,6.8,1z M8.5,4.5V1.8c0-1-0.8-1.8-1.8-1.8 S5,0.8,5,1.8v5.3L3.8,7.3C3,7.5,2.5,8.2,2.6,9l0.3,3.1c0,0.4,0.2,0.8,0.4,1.1l1.4,2.1C5.1,15.7,5.5,16,6,16h6.4c0.5,0,1-0.3,1.3-0.8 l1.4-2.4c0.2-0.4,0.4-0.9,0.4-1.4l0.3-2.7c0.1-1.1-0.7-2.1-1.8-2.2c-0.1,0-0.1,0-0.2,0h-0.6c-0.1-0.1-0.1-0.2-0.2-0.2 c-0.2-0.2-0.5-0.6-0.9-0.7c-0.4-0.1-0.8-0.1-1.2-0.1l-0.1,0c-0.1-0.3-0.3-0.5-0.6-0.6c-0.2-0.1-0.5-0.2-0.7-0.3 C9.3,4.4,8.9,4.5,8.5,4.5L8.5,4.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccess);
export default __webpack_public_path__ + "static/media/access.58b328cefe5094d303aa6acd526b67e2.svg";
export { ForwardRef as ReactComponent };